import { styled } from '@mui/material/styles';

import Base02Container from 'src/components/Base02Container';

export const Container = styled(Base02Container)(({ theme }) => ({
  color: theme.colors.base01,

  marginTop: '1.6rem',
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const InfoTextContainer = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  color: theme.colors.base01,
}));

export const InfoBodyContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',

  rowGap: '1.4rem',

  marginTop: '1.4rem',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const AmountContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
});
